import { FunctionComponent } from 'react';
import { Flex } from 'portal-commons';

const FormActionLayout: FunctionComponent = ({ children }) => (
  <Flex
    sx={{
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '9px',
      width: '100%',
      marginTop: '10px',
    }}
  >
    {children}
  </Flex>
);

export default FormActionLayout;
